import Roles from '@/auth/roles';
import PositionForm from './position-form';
import PositionList from './position-list';
import PositionHistoryFull from './position-history/position-history-full/position-history-full';
import PositionHistorySingle from './position-history/position-history-single/position-history-single';
import PositionShow from './position-show';

const roles = Roles.values;

export default [
  {
    name: 'positionList',
    path: 'position',
    component: PositionList,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.positionViewer.id,
        roles.positionEditor.id
      ]
    }
  },
  {
    name: 'positionNew',
    path: 'position/new',
    component: PositionForm,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.positionEditor.id
      ]
    }
  },
  {
    name: 'positionEdit',
    path: 'position/:id/edit',
    component: PositionForm,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.positionEditor.id
      ]
    }
  },
  {
    name: 'positionHistorySingle',
    path: 'position/:id/history',
    component: PositionHistorySingle,
    props: true,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'positionHistoryFull',
    path: 'position/history',
    component: PositionHistoryFull,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'positionShow',
    path: 'position/:id',
    component: PositionShow,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.positionViewer.id,
        roles.positionEditor.id
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/entities/position/position-routes.js